<template>
  <v-autocomplete
    v-model="authorId"
    :items="page.authors"
    item-text="name"
    item-value="id"
    label="Rédacteur (signature)"
    :loading="page.loading"
    :no-data-text="
      !forceSiteId
        ? 'Sélectionnez un site'
        : page.loading
        ? 'Chargement…'
        : 'Aucun rédacteur trouvé'
    "
    outlined
    :dense="dense"
    hide-details
    clearable
    :disabled="!forceSiteId"
  />
</template>

<script>
import { computed, onMounted, reactive, watch } from "@vue/composition-api";

import useAxios from "@/hooks/useAxios";

export default {
  name: "WpAuthorFilter",
  props: {
    initialValue: {
      default: null,
    },
    forceSiteId: {
      type: Number,
      default: 0,
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { axiosGet } = useAxios();

    const page = reactive({
      authors: [],
      authorId: null,
      loading: false,
    });

    const loadAuthors = async () => {
      if (!props.forceSiteId) {
        page.authors = [];
        page.authorId = null;
        emit("valueChanged", null);
        return;
      }

      page.loading = true;
      try {
        const { data } = await axiosGet("/aif-auto-configs/wp-authors", {
          site_id: props.forceSiteId,
        });
        page.authors = data || [];
      } finally {
        page.loading = false;
      }

      const currentId = Number(page.authorId || 0);
      const exists = page.authors.some((item) => Number(item.id) === currentId);
      if (!exists) {
        page.authorId = null;
        emit("valueChanged", null);
      }
    };

    const authorId = computed({
      get: () => page.authorId,
      set: (value) => {
        const normalized = Number(value || 0) || null;
        page.authorId = normalized;
        emit("valueChanged", normalized);
      },
    });

    watch(
      () => props.initialValue,
      (value) => {
        page.authorId = Number(value || 0) || null;
      },
      { immediate: true }
    );

    watch(
      () => props.forceSiteId,
      async () => {
        await loadAuthors();
      }
    );

    onMounted(async () => {
      await loadAuthors();
    });

    return {
      authorId,
      page,
    };
  },
};
</script>
